import axios from '../Backend';

// Health check
export const checkHealth = async () => {
    const res = await axios.get('/api/v2/azure/health');
    return res.data;
}

// Configuration
export const getConfig = async () => {
    const res = await axios.get('/api/v2/azure/config');
    return res.data;
}

export const updateConfig = async (config) => {
    const res = await axios.patch('/api/v2/azure/config', config);
    return res.data;
}

// OAuth Flow
export const initiateAuth = async (frontendCallbackUrl) => {
    const res = await axios.post('/api/v2/azure/auth/initiate', { frontendCallbackUrl });
    return res.data;
}

export const oauthCallback = async (code, state) => {
    const res = await axios.post('/api/v2/azure/auth/callback', { code, state });
    return res.data;
}

// Account Management
export const getAccounts = async () => {
    const res = await axios.get('/api/v2/azure/accounts');
    return res.data;
}

export const deleteAccount = async (accountId) => {
    const res = await axios.delete(`/api/v2/azure/accounts/${accountId}`);
    return res.data;
}

export const activateAccount = async (accountId) => {
    const res = await axios.post(`/api/v2/azure/accounts/${accountId}/activate`);
    return res.data;
}

export const deactivateAccount = async (accountId) => {
    const res = await axios.post(`/api/v2/azure/accounts/${accountId}/deactivate`);
    return res.data;
}

export const pollAccount = async (accountId) => {
    const res = await axios.post(`/api/v2/azure/accounts/${accountId}/poll`);
    return res.data;
}
